module.exports = __webpack_public_path__ + "static/img/tese-img1.1c2a028.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/tese-img1.png
// module id = 932
// module chunks = 0